import { useState } from "react";
import { tourManager } from "@/utils/tourManager";

export const useGrandTour = () => {
  const [shouldShowTour, setShouldShowTour] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState(0);

  // useEffect(() => {
  //   // Check if grand tour should be shown
  //   const showTour = tourManager.shouldShowGrandTour();
  //   setShouldShowTour(showTour);

  //   // Get days remaining
  //   const remaining = tourManager.getDaysRemaining();
  //   setDaysRemaining(remaining);
  // }, []);

  const hideTour = () => {
    tourManager.hideGrandTour();
    setShouldShowTour(false);
  };

  const completeTour = () => {
    tourManager.completeGrandTour();
    setShouldShowTour(false);
  };

  const dismissTour = () => {
    tourManager.dismissGrandTour();
    setShouldShowTour(false);
  };

  const resetTour = () => {
    tourManager.resetTourData();
    setShouldShowTour(false);
    setDaysRemaining(0);
  };

  return {
    shouldShowTour,
    daysRemaining,
    hideTour,
    completeTour,
    dismissTour,
    resetTour,
  };
};
